import { useSnapshot } from 'valtio';

import { announcementsState } from '..';

function useAnnouncements() {
  const state = useSnapshot(announcementsState);
  return state;
}

export default useAnnouncements;
